import { ospThemes } from "@ospweb/sdk-ui";
import React from "react";
import { cn } from "utils";

export interface SegmentedBarItem {
  /** 数值 */
  value: number;
  /** 颜色 */
  color: string;
  /** 标识符（可选，用于 key） */
  id?: string;
}

interface SegmentedBarProps {
  /** 数据列表 */
  data: SegmentedBarItem[];
  /** 是否显示剩余部分 */
  showRemaining?: boolean;
  /** 剩余部分的颜色 */
  remainingColor?: string;
  /** 自定义类名 */
  className?: string;
}

export const SegmentedBar: React.FC<SegmentedBarProps> = ({
  data,
  showRemaining = true,
  remainingColor = ospThemes.colors.background_white_overlay20,
  className,
}) => {
  const isEmpty = data.every((item) => !item.value);
  // 如果 data 为空，显示空状态
  if (isEmpty) {
    return (
      <div
        className={cn(
          "flex w-full overflow-hidden rounded-xl h-2 rounded-xl bg-background_white_overlay10",
          className,
        )}
      />
    );
  }

  // 计算总值
  const totalValue = data.reduce((sum, item) => sum + item.value, 0);

  // 计算剩余百分比
  const remainingPercentage = Math.max(0, 100 - totalValue);

  return (
    <div
      className={cn(
        "flex w-full overflow-hidden rounded-xl h-2 gap-1",
        className,
      )}
    >
      {data.map((item, index) => (
        <div
          key={item.id || `segment-${index}`}
          className="h-full rounded-xl min-w-1"
          style={{
            width: `${item.value}%`,
            backgroundColor: item.color,
          }}
        />
      ))}

      {showRemaining && remainingPercentage > 0 && (
        <div
          className="h-full rounded-xl"
          style={{
            width: `${remainingPercentage}%`,
            backgroundColor: remainingColor,
          }}
        />
      )}
    </div>
  );
};
